export const USER_LIST_CONSTANT = {
  FORM_SEARCH: {
    ID: 'usernameSearch',
    NAME: 'nameSearch',
    COMPANY: 'companySearch',
    STORE: 'storeSearch',
    ROLE: 'roleSearch',
  },
  FORM_MODAL: {
    MODAL_USERNAME: 'usernameModal',
    MODAL_NAME: 'nameModal',
    MODAL_PASSWORD: 'passwordModal',
    MODAL_COMPANY: 'companyCodeModal',
    MODAL_STORE: 'storeCodeModal',
    MODAL_SECTOR: 'sectorCodeModal',
    MODAL_PROCESSING_CENTER: 'processingCenterModal',
    MODAL_ROLE: 'roleModal',
  },

  TABLE_KEY: {
    NO: 'no',
    ID: 'userName',
    NAME: 'fullName',
    ROLE: 'roleCode',
    COMPANY_CODE: 'companyCode',
    SECTOR_CODE: 'sectorCode',
    STORE_CODE: 'storeCode',
    PROCESSING_CENTER_CODE: 'processingCenterCode',
    PROCESSING_CENTER_NAME: 'processingCenterName',
  },
  PING_STATUS: {
    GOOD: 'Good',
    BAD: 'Bad',
  },
};

export const DATE_FORMAT = 'MM/DD/YYYY';

export const FORM_LIST_NAME = {
  FORM_LIST: 'regisCameraFormList',
  COMPANY: 'companyId',
  STORE_CODE: 'storeId',
  EQUIPMENT_INSTALLATION_DATE: 'equipmentInstallationDate',
  CENTER_CODE: 'processingCenterId',
  INSTALLATION_LOCATION: 'location',
  RESOLUTION: 'resolution',
  ID: 'id',
  PASSWORD: 'password',
  IP_ADDRESS: 'ipAddress',
  PANNING_POSSIBLE: 'panningPossible',
  PANNING_COUNT: 'panningCount',
  DEVICE_TYPE: 'deviceType',
  PRESET_POSITION: 'presetPositions',
};

export const CONFIG_POSITION_COLUMN_NAME = {
  ORDER_POSITION: 'orderPosition',
  POSITION: 'presetValue',
  ACTION: 'action',
};
